/* istanbul ignore file */
// https://hello.jira.atlassian.cloud/browse/ITFO-20747
import React, { useState } from 'react';
import { Help } from '@atlaskit/atlassian-navigation';
import { AnalyticsTrackSubject, trackButtonClick } from '@atlassian/temp-analytics';
import { InProductHelpWindow } from '../in-product-help';

export const SelfHelp = () => {
  // const { open, isOpen, close } = useOpenClose();
  const [isOpen, setIsOpen] = useState(false);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  return (
    <>
      <Help
        testId="help-button-iph"
        isSelected={isOpen}
        onClick={() => {
          if (!isOpen) {
            open();
            trackButtonClick(AnalyticsTrackSubject.SELF_HELP, {});
          } else {
            close();
          }
        }}
        tooltip="Help"
      />
      <InProductHelpWindow isOpen={isOpen} onClose={close} />
    </>
  );
};
